import formatNumber from './formatNumber';

const getHrsMinString = (durationMinutes: number): string => {
  const hours = Math.floor(durationMinutes / 60);
  const minutes = Math.floor(durationMinutes % 60);
  let res = '';

  if (durationMinutes <= 0) {
    return '0 m';
  }

  if (hours > 0) {
    res += `${formatNumber(hours)}h `;
  }

  if (minutes > 0) {
    res += `${minutes}m`;
  }

  return res;
};

export default getHrsMinString;
